module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (2).89d48985.jpg";